import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// ============================================================================
// MEMBER API
// ============================================================================

export const memberAPI = {
  signup: async (data) => {
    const response = await axios.post(`${API_URL}/members/signup`, data);
    return response.data;
  },

  getByEmail: async (email) => {
    try {
      const response = await axios.get(`${API_URL}/members/email/${email}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  getById: async (memberId) => {
    const response = await axios.get(`${API_URL}/members/${memberId}`);
    return response.data;
  }
};

// ============================================================================
// TIRE API
// ============================================================================

export const tireAPI = {
  getAll: async (category = null) => {
    const url = category ? `${API_URL}/tires?category=${category}` : `${API_URL}/tires`;
    const response = await axios.get(url);
    return response.data;
  },

  search: async (size) => {
    const response = await axios.get(`${API_URL}/tires/search?size=${encodeURIComponent(size)}`);
    return response.data;
  }
};

// ============================================================================
// ORDER API
// ============================================================================

export const orderAPI = {
  create: async (orderData) => {
    const response = await axios.post(`${API_URL}/orders`, orderData);
    return response.data;
  },

  getByOrderNumber: async (orderNumber) => {
    const response = await axios.get(`${API_URL}/orders/${orderNumber}`);
    return response.data;
  },

  getByMemberEmail: async (email) => {
    const response = await axios.get(`${API_URL}/orders/member/${encodeURIComponent(email)}`);
    return response.data;
  }
};

// ============================================================================
// BOOKING API
// ============================================================================

export const bookingAPI = {
  create: async (bookingData) => {
    const response = await axios.post(`${API_URL}/bookings`, bookingData);
    return response.data;
  },

  getByBookingNumber: async (bookingNumber) => {
    const response = await axios.get(`${API_URL}/bookings/${bookingNumber}`);
    return response.data;
  },

  getByMemberEmail: async (email) => {
    const response = await axios.get(`${API_URL}/bookings/member/${encodeURIComponent(email)}`);
    return response.data;
  }
};

// ============================================================================
// CONTACT API
// ============================================================================

export const contactAPI = {
  submit: async (contactData) => {
    const response = await axios.post(`${API_URL}/contact`, contactData);
    return response.data;
  }
};
